export const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100, 500]

export const SOURCE_OPTIONS = [
    { value: '', label: 'Select Source' },
    { value: 'website', label: 'Website' },
    { value: 'facebook', label: 'Facebook' },
    { value: 'email', label: 'Email' },
    { value: 'phone', label: 'Phone' },
    // { value: 'walk-in', label: 'Walk In' },
]

export const STATUS_OPTIONS = [
    { value: '', label: 'Select Status' },
    { value: false, label: 'Active' },
    { value: true, label: 'InActive' },
]

export const TABLE_COLUMNS = [
    { key: 'original_name', label: 'Original Name' },
    { key: 'name', label: 'Name' },
    // { key: 'source', label: 'Source' },
    { key: 'campaign_id', label: 'Campaign Id' },
    // { key: 'status', label: 'Status' },
    { key: 'actions', label: 'Action' },
]
